"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* istanbul ignore next */
/** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */
function ColumnGroup(_) {
    return null;
}
exports.default = ColumnGroup;
//# sourceMappingURL=ColumnGroup.js.map